import { createContext, useContext } from 'react';

/**
 * The filter ids currently rendered as fields in the filter bar.
 *
 * A filter shown in the bar states its own value, so repeating it as a chip
 * below the table header is noise. A filter applied from inside the tray has
 * nothing on screen once the tray closes — that one still needs its chip, or
 * the list is scoped for reasons the user cannot see.
 */
export const InlineFiltersContext = createContext<ReadonlyArray<string>>([]);

export const useInlineFilters = (): ReadonlyArray<string> =>
	useContext(InlineFiltersContext);
